import React, {useState} from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import Date from "../deadlines/addDeadline/date";
import Total from "../deadlines/addDeadline/total";
import Payment from "../deadlines/addDeadline/payment";
import Counterpart from "../deadlines/addDeadline/counterpart";
import Description from "../deadlines/addDeadline/description";
import DocumentBrowsing from "../general/DocumentBrowsing";
import Uploader from "../../components/uploader";
import { resetUploadDocument, uploadDocuments } from "../../store/actions/documents/upload";
import DeadlineChips from "../deadlines/addDeadline/deadlineChips";
import "../deadlines/addDeadline/style.scss";
import "./addDeadlineForm.scss";

const AddDeadlineForm = ({
  isSave,  
  requestBody,
  setRequestBody,  
  frequencyDates,
  setFrequencyDates,
  documents,
  setDocuments,
  inModal,
  setDocumentsAdded
}) => {

  const main = useSelector(state => state.main);
  const documents1 = useSelector(state => state.documents);
  const upDocuments = useSelector(state => uploadedDocuments);
  const permissionUser = useSelector(state => state.currentPermissions.permissionUser);

  const [uploadedDocuments, setUploadedDocuments] = useState([]);

  const addDocument = document => {
    let newdocs = { ...documents };
    let newdocsid = [];
    if (!newdocs[document.documentId]) {
      newdocs[document.documentId] = document;
    }
    for (let item in newdocs) {
      if (newdocs.hasOwnProperty(item)) {
        newdocsid.push({
          appId: "DBX",
          featureCode: "CORE",
          id: item
        });
      }
    }
    setDocuments(newdocs);
    setRequestBody({
      ...requestBody,
      attachments: newdocsid
    });
  };

  const removeDocument = documentId => {
    let newdocs = {};
    newdocs = { ...documents };
    delete newdocs[documentId];
    setDocuments(newdocs);
  };

  return (
    <div className="AddDeadlines-reconciliation">
      {!inModal &&
      <div className="reconciliation-subtitle">
        <FormattedMessage id="reconciliation.deadlines.create" />
      </div>}
      <div style={{ marginTop: 10 }}>       
        <div style={{display:"flex", gap:"15px"}}>
          <Counterpart isReconciliationForm={true}
            isSave={isSave} requestBody={requestBody} setRequestBody={setRequestBody}
          />          
        </div>
      </div>
      <div style={{  margin: "32px 0 0 0"  }}>
        <div className="add-deadline-section">
          <FormattedMessage id="deadlines.pages.create.details" />
        </div>
        <div className="reconciliation-detail-deadline">
          <div className="tripleCols">
            <Total
              isReconciliationForm={true} isSave={isSave} requestBody={requestBody} 
              setRequestBody={setRequestBody}
            />
            <Date
              frequencyDates={frequencyDates} 
              setFrequencyDates={setFrequencyDates}
              frequencyType={"single"} 
              isSave={isSave} 
              requestBody={requestBody}                 
              setRequestBody={setRequestBody}
            />
            <Payment
              isReconciliationForm={true} isSave={isSave} requestBody={requestBody} 
              setRequestBody={setRequestBody} 
            />
          </div>
          {/* <Scope
          frequencyType={"single"}
          scopeError={scopeError}
          scopeValue={scopeValue}
          requestBody={requestBody}
          onChange={setRequestBody}
          isReconciliationForm={true}
        /> */}
         
        </div>
      </div>
      <div>
        <div style={{display: "flex", marginTop: "32px"}}>
          <Description
            isSave={isSave}
            isReconciliationForm={true}               
            onChange={e => {
              setRequestBody({
                ...requestBody,
                description: {
                  title: e.target.value
                }
              });                  
            }}
            requestBody={requestBody}
          />
        </div>
        <div style={{marginTop:"20px"}}>
          {(requestBody.status.confirmed === true || requestBody.scope !== "fiscal_social_security") &&
            <div
              style={{ display: "flex"}}
            >
              <div>
                <DocumentBrowsing                
                  id={"AddDeadlineDocBrowsing"}
                  accountantSelected={main.accountantSelected}
                  accountantIdSelected={main.accountantIdSelected}
                  companySelected={main.companySelected}
                  clientIdSelected={main.clientIdSelected}
                  addDocument={addDocument}
                  selected={documents}
                  fullWidth={true}
                  placement={"top"}
                  inModal={true}
                />
                <DeadlineChips
                  documents={documents}
                  onRemoveDocument={docId => removeDocument(docId)}
                  isReconciliationForm={true}
                />
              </div>
              <div>
                <Uploader
                  accountantSelected={main.accountantSelected}
                  accountantIdSelected={main.accountantIdSelected}
                  auth={main.auth}
                  company={main.company}
                  companySelected={main.companySelected}
                  clientIdSelected={main.clientIdSelected}
                  currentPermissions={permissionUser}
                  documents={documents1}                  
                  resetUploadDocument={() => resetUploadDocument()}
                  uploadDocuments={() => uploadDocuments()}
                  user={main.user}
                  myType={main.myType}
                  isFoldersEdit={false}
                  uploadDocAction={() => setUploadedDocuments(upDocuments)}
                  newDeadline={true}
                  setDocumentsAdded={setDocumentsAdded}
                />
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  );
};

export default AddDeadlineForm;
